import * as actionTypes from '../actions/actionTypes';

const initialState = { products: [] }

const productsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_PRODUCTS:
            {
                return {
                    ...state,
                    products: action.products
                }
            }
        case actionTypes.CREATE_PRODUCT:
            {
                return {
                    ...state,
                    products: [...state.products, action.product]
                }
            }
        case actionTypes.UPDATE_PRODUCT:
            {
                return {
                    ...state,
                    products: state.products.map((item) => {
                        if (item.id === action.data.id) {
                            return {...action.data }
                        }
                        return item
                    })
                }
            }
        case actionTypes.DELETE_PRODUCT:
            {
                return {
                    ...state,
                    products: state.products.filter(product => product.id !== action.id)
                }
            }
        default:
            {
                return state
            }
    }
}

export default productsReducer;